/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetDetailedStockArgs = {
  numero: string;
  marca: string;
  dispatcherTaxId: string[];
};

type GetDetailedStockResponse = {
  mensaje: string;
  ok: boolean;
};

export const generateANPSharedExport = async ({
  marca,
  numero,
  dispatcherTaxId,
}: GetDetailedStockArgs): Promise<GetDetailedStockResponse> => {
  try {
    const res = await apiClient.post<any>(Endpoints.ANPSharedExport, {
      marca,
      numero,
      rut: dispatcherTaxId,
    });
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
